import { Controller } from 'front-end-core/core/Router'
import Main from './Main'
import Header from './Header'
import { LEGISLATION_FOLDERS } from 'constants/feature-flags'
import { LEGISLATION_MENU } from 'constants/controllers'
import { DefaultFlavourRedirect } from 'helpers/redirects'

export default new Controller({
  name: LEGISLATION_MENU,
  route: LEGISLATION_FOLDERS ? ':aol/legislation/all' : ':aol/legislation',
  controller: DefaultFlavourRedirect(LEGISLATION_MENU, function (Router, { url, scrollMain, pageView, pageData, params: { aol, path = null }, previousPageId, query }, render) {
    const pageId = url

    render(
      { Main, Header },
      { aol, act: path, scrollMain },
      {
        aol,
        pageId,
        searchType: 'legislation',
        className: 'legislation legislation-accordion-namespace'
      }
    )

    return pageId
  })
})
